import * as types from '../mutation-types'

const state = {
  stage: 0
}

// getters
const getters = {
  getStage: state => state.stage
}

// actions
const actions = {
  setStage ({ commit }, payload) {
    commit(types.SET_STAGE, payload)
  }
}

// mutations
const mutations = {
  [types.SET_STAGE] (state, num) {
    state.stage = num
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/oppotunity.js